import { EXECUTION_SECTION_ID, lookupOrderIdForWorkOrder } from "./workOrders";

/**
 * Resolve a customer-portal path for a notification deep link.
 *
 * A `WorkOrder` notification has no order id, so it opens the order's Execution section when
 * the customer has loaded that order before (see `rememberWorkOrderOrders`) and otherwise
 * falls back to the orders list.
 */
export function resolveNotificationPath(entityType: string, entityId: string): string | null {
  if (!entityId) return null;

  switch (entityType) {
    case "Order":
      return `/orders/${entityId}`;
    case "WorkOrder": {
      const orderId = lookupOrderIdForWorkOrder(entityId);
      return orderId ? `/orders/${orderId}#${EXECUTION_SECTION_ID}` : "/orders";
    }
    case "CustomerRequest":
      return `/requests/${entityId}`;
    case "WalletTopUp":
      // Avoid ?topUpId= — ProfileWalletPage treats it as gateway confirm state.
      return "/profile/wallet";
    default:
      return null;
  }
}
